import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEmbarques } from "@/hooks/useEmbarques";
import { Ship } from "lucide-react";

interface Props {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export function EmbarqueSelectField({ value, onValueChange, className }: Props) {
  const { data: embarques = [] } = useEmbarques();

  return (
    <Select value={value || "__none__"} onValueChange={(v) => onValueChange(v === "__none__" ? "" : v)}>
      <SelectTrigger className={className}>
        <div className="flex items-center gap-2">
          <Ship className="h-3.5 w-3.5 text-muted-foreground" />
          <SelectValue placeholder="Sin embarque asignado" />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">Sin embarque asignado</SelectItem>
        {embarques.map((e) => (
          <SelectItem key={e.id} value={e.id}>
            {e.numero_do}{e.proveedor ? ` — ${e.proveedor}` : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
